import React from "react";

import { IRoundQuantityPickerProps } from "@faire/retailer/components/RoundQuantityPicker";
import { IRoundQuantityPickerStateProps } from "@faire/retailer/components/RoundQuantityPicker/UseRoundQuantityPickerState";
import { ProductTileInfo } from "@faire/retailer/features/MarketplaceItems/ProductTile";
import { loadable } from "@faire/retailer/lib/loadable";
import { handleComponentLoadError } from "@faire/retailer/lib/loadChunkErrors";
import { UpdateCartHandler } from "@faire/retailer/stores/domain/CartStore/consts";

export interface IEncapsulatedQuickAddProps {
  productTile: ProductTileInfo;
  imageContainerRef?: React.RefObject<HTMLDivElement | null>;
  updateItems?: UpdateCartHandler;
  onQuickAddClick?: (newQuantity?: number) => void;
  onQuickAddSubmit?: (newQuantity?: number) => void;
  onChooseOption?: () => void;
  onChooseOptionQuantityUpdate?: (newQuantity?: number) => void;
  renderCollapsableQuickAddButtonProps?: IRoundQuantityPickerProps &
    IRoundQuantityPickerStateProps;
  disableQuickAddWithFaireProtectionTooltip?: boolean;
  className?: string;
  getCartItemTokenByProductToken?: (productToken: string) => void;
  shortenDebounce?: boolean;
  // In some places, we show a hovered text like "choose options", but
  //  in other places we show the multi-option modal on click.
  showModalOnClick?: boolean;
}

export const LazyEncapsulatedQuickAdd = loadable(
  () =>
    import(
      /* webpackChunkName: "encapsulated-quick-add" */ "./EncapsulatedQuickAdd"
    ).catch(handleComponentLoadError),
  { resolveComponent: (m) => m.EncapsulatedQuickAdd }
);
